module.exports = __webpack_public_path__ + "static/loiter_landing-88eb00fc9690ab6cf45a393a48f72a62.jpg";